import { useState } from 'react';

import { Inner, Message, Content } from './source-input-wrapper.styled';

export const Wrapper = (props) => {
  const {
    Tip,
    meta: { error, touched },
    simpleErrorWrapper,
    asFilter,
  } = props;
  const Field = props.component;
  const [showTip, setShowTip] = useState(false);

  const getErrorMessage = (error) => {
    switch (error) {
      case 'wrong_value':
        return 'Неправильное значение';
      case 'duplicate':
        return 'Значение уже используется';
      default:
        return error;
    }
  };

  let cl = touched && error ? 'error' : '';
  let clField = props.className ?? '';
  if (simpleErrorWrapper && cl) {
    cl += ' simple';
  }
  let cl1 = '';
  if (asFilter) {
    cl1 += ' as-filter';
  }
  clField += ' ' + cl;

  return (
    <Content>
      <Inner className={cl} onMouseEnter={() => setShowTip(true)} onMouseLeave={() => setShowTip(false)}>
        <Field {...props} className={clField} />
        {touched && error && showTip && <Message className={cl1}>{getErrorMessage(error)}</Message>}
      </Inner>
      {Tip && <Tip />}
    </Content>
  );
};
